module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms_01_m_en.48fcb42d40343f814791707fc935f2ef.png";